import { FC, useEffect, useMemo } from 'react'
import { Box, Input, Select } from '@chakra-ui/react'
import { UseFormRegister } from 'react-hook-form'

import { FormItem } from 'components'
import { SALARY_INITIAL_FILTER_FIELDS } from 'InstitutionalManagement/constants/pages/salaries'
import { SalaryFieldsName, SalaryFilterKeyString } from 'InstitutionalManagement/types'
import { STATUS_OPTIONS } from 'constants/variables'
import { focusElementById } from 'utils/events'

type Props = {
  hasPrefix?: boolean
  isOpen?: boolean
  register: UseFormRegister<SalaryFilterKeyString>
  onlyFields?: SalaryFieldsName[]
}

const SalaryFilterForm: FC<Props> = ({ hasPrefix, isOpen = false, register, onlyFields }) => {
  const salaryFilterFields = useMemo(() => {
    return onlyFields || SALARY_INITIAL_FILTER_FIELDS
  }, [])

  function setPrefix(key: SalaryFieldsName) {
    if (hasPrefix) return `salary_${key}`
    return key
  }

  useEffect(() => {
    focusElementById('name')
  }, [isOpen])

  return (
    <Box>
      {salaryFilterFields.includes('id') && (
        <FormItem label="ID" htmlFor="id">
          <Input id="id" {...register(setPrefix('id'))} />
        </FormItem>
      )}
      {salaryFilterFields.includes('name') && (
        <FormItem label="Nome" htmlFor="name">
          <Input id="name" {...register(setPrefix('name'))} />
        </FormItem>
      )}
      {salaryFilterFields.includes('description') && (
        <FormItem label="Descrição" htmlFor="description">
          <Input id="description" {...register(setPrefix('description'))} />
        </FormItem>
      )}
      {salaryFilterFields.includes('status') && (
        <FormItem label="Status" htmlFor="status">
          <Select id="status" {...register(setPrefix('status'))}>
            {STATUS_OPTIONS.map(({ label, value }) => {
              return (
                <option key={value} value={value}>
                  {label}
                </option>
              )
            })}
          </Select>
        </FormItem>
      )}
    </Box>
  )
}

export default SalaryFilterForm
